// extracted by mini-css-extract-plugin
export var layoutContainer = "_a9-0";
export var layoutContainerNoRounding = "_a9-6";
export var layoutContainerOpen = "_a9-5";
export var layoutContainerResizing = "_a9-1";
export var mainContent = "_a9-2";
export var resizeDivider = "_a9-3";
export var slidePanel = "_a9-4";